{
  "metrics": {
    "totalCustomers": "Kunden gesamt",
    "thisMonth": "diesen Monat",
    "weeklyActive": "Wöchentlich aktiv",
    "monthlyActive": "Monatlich aktiv",
    "ofTotalCustomers": "{{percent}} % aller Kunden"
  }
}
